export default "__VITE_ASSET__DTcpc27U__"